/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WeatherMoonIcon20Regular = forwardRef('WeatherMoonIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.25 2.777c.238.261.342.658.197 1.04a6 6 0 0 0 7.735 7.735c.383-.144.78-.04 1.041.197.27.244.422.658.262 1.08A8 8 0 1 1 7.17 2.515a.982.982 0 0 1 1.08.263ZM6.725 4.384a6.5 6.5 0 1 0 8.892 8.892 7.5 7.5 0 0 1-8.892-8.892Z" })));
});
